'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var react = require('@emotion/react');
var moment = require('moment');
var reactResponsive = require('react-responsive');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);

const colors = {
    primary: {
        goldDark: "#8F764A",
        gold: "#BEAB89",
        goldLight: "#DED7CC",
        platinumDark: "#8F837F",
        platinum: "#A5A19A",
        platinumLight: "#D6D0CA",
        forestGreen: "#117733",
        savingsRed: "#E73F32",
    },
    semantic: {
        red: "#DD1133",
        orange: "#EE6E1A",
        yellow: "#FFCC00",
        green: "#00AA66",
        blue: "#0088EE",
    },
    tone: {
        black: "#000000",
        anthraciteDark: "#333333",
        anthracite: "#666666",
        anthraciteLight: "#999999",
        silver: "#CCCCCC",
        marble: "#F0F0F0",
        sand: "#F9F9F9",
        white: "#FFFFFF",
    },
    marketing: {
        adriaticBlue: "#2F5A8B",
        azureBlue: "#BBD3EC",
        candyPink: "#EDC8CB",
        chinaWhite: "#FAF2D5",
        citrine: "#EEBC32",
        claret: "#451F1F",
        emerald: "#327A5F",
        fuschiaPink: "#B94982",
        lavender: "#B8AAD0",
        mandarin: "#DF7937",
        midGreen: "#576946",
        parkGreen: "#AAD5AE",
        purple: "#55307F",
        racingGreen: "#2D3A2E",
        sapphire: "#32337F",
        scarlet: "#812024",
        sorbetYellow: "#FFE5B7",
        stone: "#E0C7A3",
        tabrizBlue: "#2274B5",
        turquouise: "#4CADB0",
    },
};

const BREAKPOINTS = {
    xs: "0",
    sm: "600px",
    md: "905px",
    lg: "1240px",
    xl: "1440px",
};
const breakpoints = Object.values(BREAKPOINTS);
const createMediaQuery$1 = (bp) => `@media screen and (min-width: ${bp})`;
const mediaQueryList = breakpoints.map(createMediaQuery$1);

var PropMapScale;
(function (PropMapScale) {
    PropMapScale["space"] = "space";
    PropMapScale["colors"] = "colors";
    PropMapScale["selectors"] = "selectors";
})(PropMapScale || (PropMapScale = {}));

var space$1;
(function (space) {
    space["_4"] = "4px";
    space["_8"] = "8px";
    space["_12"] = "12px";
    space["_16"] = "16px";
    space["_24"] = "24px";
    space["_32"] = "32px";
    space["_48"] = "48px";
    space["_64"] = "64px";
    space["_96"] = "96px";
})(space$1 || (space$1 = {}));
const scale = PropMapScale.space;
const spacePropMap = {
    p: { scale, props: ["padding"] },
    pt: { scale, props: ["paddingTop"] },
    pr: { scale, props: ["paddingRight"] },
    pb: { scale, props: ["paddingBottom"] },
    pl: { scale, props: ["paddingLeft"] },
    px: { scale, props: ["paddingLeft", "paddingRight"] },
    py: { scale, props: ["paddingTop", "paddingBottom"] },
    m: { scale, props: ["margin"] },
    mt: { scale, props: ["marginTop"] },
    mr: { scale, props: ["marginRight"] },
    mb: { scale, props: ["marginBottom"] },
    ml: { scale, props: ["marginLeft"] },
    mx: { scale, props: ["marginLeft", "marginRight"] },
    my: { scale, props: ["marginTop", "marginBottom"] },
};

const typographyVariant = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h4_b2b: "h4_b2b",
    h1_m: "h1_m",
    h2_m: "h2_m",
    h3_m: "h3_m",
    h4_m: "h4_m",
    h4_b2b_m: "h4_b2b_m",
    insp: "insp",
    insp_m: "insp_m",
    default: "default",
    default_link: "default_link",
    default_strike: "default_strike",
    default_bold: "default_bold",
    default_bold_link: "default_bold_link",
    default_semibold: "default_semibold",
    default_semibold_link: "default_semibold_link",
    small: "small",
    small_link: "small_link",
    small_strike: "small_strike",
    small_bold: "small_bold",
    small_bold_link: "small_bold_link",
    small_semibold: "small_semibold",
    small_semibold_link: "small_semibold_link",
    xsmall: "xsmall",
    xsmall_link: "xsmall_link",
    xsmall_bold: "xsmall_bold",
    xsmall_semibold: "xsmall_semibold",
    xsmall_bold_link: "xsmall_bold_link",
};
const typographyTag = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    p: "p",
    div: "div",
    span: "span",
};
const fontFamily = {
    SSP: "Source Sans Pro, sans-serif",
    CSILW: "CharisSILW",
    PlusJakarta: "Plus Jakarta Sans, sans-serif",
};
const fontWeight = {
    _400: 400,
    _600: 600,
    _700: 700,
};
const fontSize = {
    _12: "12px",
    _14: "14px",
    _16: "16px",
    _18: "18px",
    _20: "20px",
    _22: "22px",
    _24: "24px",
    _32: "32px",
    _48: "48px",
    _64: "64px",
    _72: "72px",
};
const typography$1 = {
    fontSize,
    fontWeight,
    fontFamily,
};

const effects = {
    blur: {
        _4: "blur(4px)",
    },
    border: {
        _1: "1px",
        _2: "2px",
    },
    gradient: {
        black_50: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)",
        black_75: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 100%)",
        black_100: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1.0) 100%)",
        white_hor: "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1.0) 100%)",
        white_ver: "linear-gradient(-90deg, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%)",
    },
    line: {
        border: "1px solid #DDDDDD",
        hr: `position: absolute; margin: 0; width: 100%; height: 1px; border: none; background: #DDDDDD;`,
    },
    overlay: {
        black_10: "rgba(0, 0, 0, 0.1)",
        black_25: "rgba(0, 0, 0, 0.25)",
        black_50: "rgba(0, 0, 0, 0.5)",
        black_75: "rgba(0, 0, 0, 0.75)",
        white_15: "rgba(255, 255, 255, 0.15)",
        white_25: "rgba(255, 255, 255, 0.25)",
        white_50: "rgba(255, 255, 255, 0.5)",
        white_75: "rgba(255, 255, 255, 0.75)",
    },
    rounding: {
        _2: "2px",
        _4: "4px",
        _8: "8px",
    },
    shadow: {
        inner: "0px 0px 48px 0px rgba(0, 0, 0, 0.1) inset",
        hover: "0px 8px 24px 0px rgba(0, 0, 0, 0.1)",
        up: "0px -4px 8px rgba(0, 0, 0, 0.08)",
        down: "0px 2px 8px 0px rgba(0, 0, 0, 0.16)",
    },
};

const variants = {
    centered: {
        justifyContent: "center",
        alignItems: "center",
    },
};

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */ && prop.charCodeAt(1) === 110
  /* n */ && prop.charCodeAt(2) < 91;
}
/* Z+1 */);

var isBrowser$2 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false ||
  // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$2 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;
    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
      if (!isBrowser$2 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }
      current = current.next;
    } while (current !== undefined);
    if (!isBrowser$2 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
    i = 0,
    len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array

  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.

  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }
  return value;
};
if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};
  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }
    var processed = oldProcessStyleValue(key, value);
    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }
    return processed;
  };
}
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }
  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
    }
    return interpolation;
  }
  switch (_typeof(interpolation)) {
    case 'boolean':
      {
        return '';
      }
    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }
        if (interpolation.styles !== undefined) {
          var next = interpolation.next;
          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }
          var styles = interpolation.styles + ";";
          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }
          return styles;
        }
        return createStringFromObject(mergedProps, registered, interpolation);
      }
    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }
        break;
      }
    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });
        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }
      break;
  } // finalize string values (regular strings and functions interpolated into css calls)

  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = '';
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (_typeof(value) !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
        }
        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }
            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }
                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && _typeof(args[0]) === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }
  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];
  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
    }
    styles += strings[0];
  } // we start at 1 since we've already handled the first arg

  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }
      styles += strings[i];
    }
  }
  var sourceMap;
  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time

  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' +
    // $FlowFixMe we know it's not null
    match[1];
  }
  var name = murmur2(styles) + identifierName;
  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }
  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var testOmitPropsOnStringTag = isPropValid;
var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;
  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }
  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }
  return shouldForwardProp;
};
var isBrowser = typeof document !== 'undefined';
var useInsertionEffect = React__namespace['useInsertion' + 'Effect'] ? React__namespace['useInsertion' + 'Effect'] : function useInsertionEffect(create) {
  create();
};
function useInsertionEffectMaybe(create) {
  if (!isBrowser) {
    return create();
  }
  useInsertionEffect(create);
}
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var isBrowser$1 = typeof document !== 'undefined';
var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
    serialized = _ref.serialized,
    isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectMaybe(function () {
    return insertStyles(cache, serialized, isStringTag);
  });
  if (!isBrowser$1 && rules !== undefined) {
    var _ref2;
    var serializedNames = serialized.name;
    var next = serialized.next;
    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }
    return /*#__PURE__*/React.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }
  return null;
};
var createStyled = function createStyled(tag, options) {
  if (process.env.NODE_ENV !== 'production') {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }
  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;
  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }
  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }
    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (process.env.NODE_ENV !== 'production' && args[0][0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }
      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;
      for (; i < len; i++) {
        if (process.env.NODE_ENV !== 'production' && args[0][i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }
        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class

    var Styled = react.withEmotionCache(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;
      if (props.theme == null) {
        mergedProps = {};
        for (var key in props) {
          mergedProps[key] = props[key];
        }
        mergedProps.theme = React.useContext(react.ThemeContext);
      }
      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }
      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;
      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }
      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};
      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;
        if (
        // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }
      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/React.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && process.env.NODE_ENV !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string

        return "." + targetClassName;
      }
    });
    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, _extends$1({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };
    return Styled;
  };
};

var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
var newStyled = createStyled.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

const retry = (fn, retriesLeft = 4, interval = 300) => {
    return new Promise((resolve, reject) => {
        fn()
            .then(resolve)
            .catch((error) => {
            setTimeout(() => {
                if (retriesLeft === 1) {
                    reject(error);
                    return;
                }
                retry(fn, retriesLeft - 1, interval).then(resolve, reject);
            }, interval);
        });
    });
};
const lazy = (fn) => React__default["default"].lazy(() => retry(() => fn()));

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  lazy: lazy
});

const isEqual = (variantA, variantB) => variantA === variantB || "";

const arrayToObject = (arr) => {
    return arr.reduce((obj, cur, index) => {
        obj[index] = cur;
        return obj;
    }, {});
};

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LazyLoading: index$4,
  isEqual: isEqual,
  arrayToObject: arrayToObject
});

const getTypographyStyles = (fontSize, lineHeight, fontFamily, fontWeight, textDecoration) => `
  font-size: ${fontSize};
  line-height: ${lineHeight};
  font-family: ${fontFamily};
  font-weight: ${fontWeight};
  text-decoration: ${textDecoration};
`;
const StyledTypography = newStyled.p `
  ${({ theme: { typography: { fontSize, fontFamily, fontWeight }, }, variant, }) => `
    margin: 0;
    
    // Desktop headers
    ${isEqual(typographyVariant.h1, variant) &&
    getTypographyStyles(fontSize._48, "58px", fontFamily.PlusJakarta, fontWeight._700, "unset")}
    ${isEqual(typographyVariant.h2, variant) &&
    getTypographyStyles(fontSize._32, "40px", fontFamily.PlusJakarta, fontWeight._700, "unset")}
    ${isEqual(typographyVariant.h3, variant) &&
    getTypographyStyles(fontSize._24, "32px", fontFamily.PlusJakarta, fontWeight._700, "unset")}
    ${isEqual(typographyVariant.h4, variant) &&
    getTypographyStyles(fontSize._20, "24px", fontFamily.PlusJakarta, fontWeight._700, "unset")}
    ${isEqual(typographyVariant.h4_b2b, variant) &&
    getTypographyStyles(fontSize._20, "24px", fontFamily.SSP, fontWeight._700, "unset")}

    // Mobile headers
    ${isEqual(typographyVariant.h1_m, variant) &&
    getTypographyStyles(fontSize._32, "40px", fontFamily.PlusJakarta, fontWeight._700, "unset")}
    ${isEqual(typographyVariant.h2_m, variant) &&
    getTypographyStyles(fontSize._24, "32px", fontFamily.PlusJakarta, fontWeight._700, "unset")}
    ${isEqual(typographyVariant.h3_m, variant) &&
    getTypographyStyles(fontSize._20, "24px", fontFamily.PlusJakarta, fontWeight._700, "unset")}
    ${isEqual(typographyVariant.h4_m, variant) &&
    getTypographyStyles(fontSize._18, "24px", fontFamily.PlusJakarta, fontWeight._700, "unset")}
    ${isEqual(typographyVariant.h4_b2b_m, variant) &&
    getTypographyStyles(fontSize._18, "24px", fontFamily.SSP, fontWeight._700, "unset")}

    // Inspirational text
    ${isEqual(typographyVariant.insp, variant) &&
    getTypographyStyles(fontSize._22, "32px", fontFamily.SSP, fontWeight._400, "unset")}
    ${isEqual(typographyVariant.insp_m, variant) &&
    getTypographyStyles(fontSize._18, "24px", fontFamily.SSP, fontWeight._400, "unset")}

    // Regular text
    ${isEqual(typographyVariant.default, variant) &&
    getTypographyStyles(fontSize._16, "24px", fontFamily.SSP, fontWeight._400, "unset")}
    ${isEqual(typographyVariant.default_semibold, variant) &&
    getTypographyStyles(fontSize._16, "24px", fontFamily.SSP, fontWeight._600, "unset")}
    ${isEqual(typographyVariant.default_bold, variant) &&
    getTypographyStyles(fontSize._16, "24px", fontFamily.SSP, fontWeight._700, "unset")}
    ${isEqual(typographyVariant.default_link, variant) &&
    getTypographyStyles(fontSize._16, "24px", fontFamily.SSP, fontWeight._400, "underline")}
    ${isEqual(typographyVariant.default_semibold_link, variant) &&
    getTypographyStyles(fontSize._16, "24px", fontFamily.SSP, fontWeight._600, "underline")}
    ${isEqual(typographyVariant.default_bold_link, variant) &&
    getTypographyStyles(fontSize._16, "24px", fontFamily.SSP, fontWeight._700, "underline")}
    ${isEqual(typographyVariant.default_strike, variant) &&
    getTypographyStyles(fontSize._16, "24px", fontFamily.SSP, fontWeight._400, "line-through")}

    // Small text
    ${isEqual(typographyVariant.small, variant) &&
    getTypographyStyles(fontSize._14, "20px", fontFamily.SSP, fontWeight._400, "unset")}
    ${isEqual(typographyVariant.small_semibold, variant) &&
    getTypographyStyles(fontSize._14, "20px", fontFamily.SSP, fontWeight._600, "unset")}
    ${isEqual(typographyVariant.small_bold, variant) &&
    getTypographyStyles(fontSize._14, "20px", fontFamily.SSP, fontWeight._700, "unset")}
    ${isEqual(typographyVariant.small_link, variant) &&
    getTypographyStyles(fontSize._14, "20px", fontFamily.SSP, fontWeight._400, "underline")}
    ${isEqual(typographyVariant.small_semibold_link, variant) &&
    getTypographyStyles(fontSize._14, "20px", fontFamily.SSP, fontWeight._600, "underline")}
    ${isEqual(typographyVariant.small_bold_link, variant) &&
    getTypographyStyles(fontSize._14, "20px", fontFamily.SSP, fontWeight._700, "underline")}
    ${isEqual(typographyVariant.small_strike, variant) &&
    getTypographyStyles(fontSize._14, "20px", fontFamily.SSP, fontWeight._400, "line-through")}

    // Extra small body text
    ${isEqual(typographyVariant.xsmall, variant) &&
    getTypographyStyles(fontSize._12, "16px", fontFamily.SSP, fontWeight._400, "unset")}
    ${isEqual(typographyVariant.xsmall_semibold, variant) &&
    getTypographyStyles(fontSize._12, "16px", fontFamily.SSP, fontWeight._600, "unset")}
    ${isEqual(typographyVariant.xsmall_bold, variant) &&
    getTypographyStyles(fontSize._12, "16px", fontFamily.SSP, fontWeight._700, "unset")}
    ${isEqual(typographyVariant.xsmall_link, variant) &&
    getTypographyStyles(fontSize._12, "16px", fontFamily.SSP, fontWeight._400, "underline")}
    ${isEqual(typographyVariant.xsmall_bold_link, variant) &&
    getTypographyStyles(fontSize._12, "16px", fontFamily.SSP, fontWeight._700, "underline")}

  `}
`;
const Typography = (_a) => {
    var { variant = "default", as = typographyTag.p, children } = _a, rest = __rest(_a, ["variant", "as", "children"]);
    return (jsxRuntime.jsx(StyledTypography, Object.assign({ variant: variant, as: as }, rest, { children: children })));
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
}
function isFunction(value) {
  return typeof value === 'function';
}
function isTheme(value) {
  return value == null ? void 0 : value.theme;
}
var defaultBreakpoints = /*#__PURE__*/[40, 52, 64].map(function (n) {
  return n + "em";
});
var defaultTheme = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72],
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var pseudoSelectors = {
  _hover: ['&:hover', '&[data-hover]'],
  _active: ['&:active', '&[data-active]'],
  _focus: ['&:focus', '&[data-focus]'],
  _highlighted: ['&[data-highlighted]'],
  _focusWithin: ['&:focus-within'],
  _focusVisible: ['&:focus-visible'],
  _disabled: ['&[disabled]', '&[aria-disabled=true]', '&[data-disabled]'],
  _readOnly: ['&[aria-readonly=true]', '&[readonly]', '&[data-readonly]'],
  _before: ['&::before'],
  _after: ['&::after'],
  _empty: ['&:empty'],
  _expanded: ['&[aria-expanded=true]', '&[data-expanded]'],
  _checked: ['&:checked', '&[aria-checked=true]', '&[data-checked]'],
  _grabbed: ['&[aria-grabbed=true]', '&[data-grabbed]'],
  _pressed: ['&[aria-pressed=true]', '&[data-pressed]'],
  _invalid: ['&[aria-invalid=true]', '&[data-invalid]'],
  _valid: ['&[data-valid]', '&[data-state=valid]'],
  _loading: ['&[data-loading]', '&[aria-busy=true]'],
  _selected: ['&[aria-selected=true]', '&[data-selected]'],
  _hidden: ['&[hidden]', '&[data-hidden]'],
  _even: ['&:nth-of-type(even)'],
  _odd: ['&:nth-of-type(odd)'],
  _first: ['&:first-of-type'],
  _last: ['&:last-of-type'],
  _notFirst: ['&:not(:first-of-type)'],
  _notLast: ['&:not(:last-of-type)'],
  _visited: ['&:visited'],
  _activeLink: ['&[aria-current=page]'],
  _indeterminate: ['&:indeterminate', '&[aria-checked=mixed]', '&[data-indeterminate]'],
  _placeholder: ['&::placeholder'],
  _fullScreen: ['&:fullscreen'],
  _selection: ['&::selection']
};
function get(obj, path, fallback) {
  var key = typeof path === 'string' ? path.split('.') : [path];
  var result = obj;
  for (var i = 0; i < key.length; i += 1) {
    if (!result) {
      break;
    }
    result = result[key[i]];
  }
  return result === undefined ? fallback : result;
}
function merge(a, b) {
  var result = _extends({}, a, b);
  Object.keys(result).forEach(function (key) {
    var _Object$assign;
    if (!a[key] || _typeof(b[key]) !== 'object') {
      return;
    }
    Object.assign(result, (_Object$assign = {}, _Object$assign[key] = Object.assign(a[key], b[key]), _Object$assign));
  });
  return result;
}
function sort(obj) {
  var result = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    result[key] = obj[key];
  });
  return result;
}
function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
}
function parseResponsiveStyles$1(mediaQueries, sx, scale, raw, props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, props);
    if (!media) {
      styles = _extends({}, styles, style);
    } else {
      var _extends2;
      styles = _extends({}, styles, (_extends2 = {}, _extends2[media] = _extends({}, styles[media], style), _extends2));
    }
  });
  return styles;
}
function parseResponsiveObject(breakpoints, sx, scale, raw, props) {
  var styles = {};
  Object.keys(raw).forEach(function (key) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, props);
    if (!breakpoint) {
      styles = _extends({}, styles, style);
    } else {
      var _extends3;
      var media = createMediaQuery(breakpoint);
      styles = _extends({}, styles, (_extends3 = {}, _extends3[media] = _extends({}, styles[media], style), _extends3));
    }
  });
  return styles;
}
var createParser = function createParser(config) {
  var cache = {};
  var parser = function parser(props) {
    var _props$theme;
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = (_props$theme = props.theme) == null ? void 0 : _props$theme.disableStyledSystemCache;
    Object.keys(props).forEach(function (key) {
      if (!config[key]) {
        return;
      }
      var sx = config[key];
      var raw = props[key];
      var scale = get(props.theme, sx.scale, sx.defaults);
      if (_typeof(raw) === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaultBreakpoints);
        if (Array.isArray(raw)) {
          var _cache$breakpoints;
          cache.media = !isCacheDisabled && cache.media || [null].concat(((_cache$breakpoints = cache.breakpoints) != null ? _cache$breakpoints : []).map(createMediaQuery));
          styles = merge(styles, parseResponsiveStyles$1(cache.media, sx, scale, raw, props));
          return;
        }
        if (raw !== null) {
          var _cache$breakpoints2;
          styles = merge(styles, parseResponsiveObject((_cache$breakpoints2 = cache.breakpoints) != null ? _cache$breakpoints2 : [], sx, scale, raw, props));
          shouldSort = true;
        }
        return;
      }
      styles = _extends({}, styles, sx(raw, scale, props));
    });
    if (shouldSort) {
      styles = sort(styles);
    }
    return styles;
  };
  parser.config = config;
  parser.propNames = Object.keys(config);
  parser.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return !['config', 'propNames', 'cache'].includes(k);
  });
  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;
      parser[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }
  return parser;
};
var compose$1 = function compose() {
  var config = {};
  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }
  parsers.forEach(function (parser) {
    if (!parser || !parser.config) {
      return;
    }
    config = _extends({}, config, parser.config);
  });
  return createParser(config);
};
function createStyleFunction(_ref) {
  var properties = _ref.properties,
    property = _ref.property,
    scale = _ref.scale,
    _ref$transform = _ref.transform,
    transform = _ref$transform === void 0 ? get : _ref$transform,
    defaultScale = _ref.defaultScale;
  var p = properties || (property ? [property] : []);
  var styleFn = function styleFn(_value, _scale, _props) {
    var result = {};
    var value = transform(_scale, _value, _value, _props);
    if (value === null) {
      return undefined;
    }
    if (Array.isArray(value) && properties.length > 1) {
      p.forEach(function (prop, index) {
        result[prop] = value[index];
      });
    } else {
      p.forEach(function (prop) {
        result[prop] = value;
      });
    }
    return result;
  };
  styleFn.properties = properties;
  styleFn.property = property;
  styleFn.scale = scale;
  styleFn.transform = transform.name !== 'get' ? transform : undefined;
  styleFn.defaults = defaultScale;
  return styleFn;
}
function system(args) {
  if (args === void 0) {
    args = {};
  }
  var config = {};
  Object.keys(args).forEach(function (key) {
    var argConfig = args[key];
    if (argConfig === false) {
      return;
    }
    // shorthand definition
    if (argConfig === true) {
      config[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }
    if (typeof argConfig === 'function') {
      config[key] = argConfig;
      return;
    }
    config[key] = createStyleFunction(argConfig);
  });
  return createParser(config);
}
var config$b = {
  animation: {
    property: 'animation',
    scale: 'animation.animation'
  },
  animationName: {
    property: 'animationName',
    scale: 'animation.name'
  },
  animationDuration: {
    property: 'animationDuration',
    scale: 'animation.duration'
  },
  animationTimingFunction: {
    property: 'animationTimingFunction',
    scale: 'animation.timingFn'
  },
  animationDelay: {
    property: 'animationDelay',
    scale: 'animation.delay'
  },
  animationIterationCount: {
    property: 'animationIterationCount'
  },
  animationDirection: {
    property: 'animationDirection'
  },
  animationFillMode: {
    property: 'animationFillMode'
  },
  animationPlayState: {
    property: 'animationPlayState'
  }
};
var animation = /*#__PURE__*/system(config$b);
var config$a = {
  background: {
    property: 'background',
    scale: 'colors'
  },
  backgroundImage: {
    property: 'backgroundImage'
  },
  backgroundClip: {
    property: 'backgroundClip'
  },
  backgroundSize: {
    property: 'backgroundSize'
  },
  backgroundPosition: {
    property: 'backgroundPosition'
  },
  backgroundRepeat: {
    property: 'backgroundRepeat'
  },
  backgroundAttachment: {
    property: 'backgroundAttachment'
  }
};
config$a.bgImage = config$a.backgroundImage;
config$a.bgClip = config$a.backgroundClip;
config$a.bgSize = config$a.backgroundSize;
config$a.bgPosition = config$a.backgroundPosition;
config$a.bgRepeat = config$a.backgroundRepeat;
config$a.bgAttachment = config$a.backgroundAttachment;
var background = /*#__PURE__*/system(config$a);
var config$9 = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  },
  borderTopWidth: {
    property: 'borderTopWidth',
    scale: 'borderWidths'
  },
  borderTopColor: {
    property: 'borderTopColor',
    scale: 'colors'
  },
  borderTopStyle: {
    property: 'borderTopStyle',
    scale: 'borderStyles'
  },
  borderBottomWidth: {
    property: 'borderBottomWidth',
    scale: 'borderWidths'
  },
  borderBottomColor: {
    property: 'borderBottomColor',
    scale: 'colors'
  },
  borderBottomStyle: {
    property: 'borderBottomStyle',
    scale: 'borderStyles'
  },
  borderLeftWidth: {
    property: 'borderLeftWidth',
    scale: 'borderWidths'
  },
  borderLeftColor: {
    property: 'borderLeftColor',
    scale: 'colors'
  },
  borderLeftStyle: {
    property: 'borderLeftStyle',
    scale: 'borderStyles'
  },
  borderRightWidth: {
    property: 'borderRightWidth',
    scale: 'borderWidths'
  },
  borderRightColor: {
    property: 'borderRightColor',
    scale: 'colors'
  },
  borderRightStyle: {
    property: 'borderRightStyle',
    scale: 'borderStyles'
  }
};
var border = /*#__PURE__*/system(config$9);
var colourNameToHex = function colourNameToHex(colour) {
  var colours = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    'indianred ': '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgrey: '#d3d3d3',
    lightgreen: '#90ee90',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370d8',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#d87093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
  };
  if (typeof colours[colour.toLowerCase()] != 'undefined') return colours[colour.toLowerCase()];
  return null;
};
var getContrast = function getContrast(hexstring, colors) {
  // eslint-disable-next-line prefer-const
  var r, g, b;
  // Check the format of the color, HEX or RGB?
  if (hexstring.match(/^rgb/)) {
    // If RGB --> store the red, green, blue values in separate variables
    var color = hexstring.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
    r = color[1];
    g = color[2];
    b = color[3];
  } else if (hexstring.match(/^#/)) {
    // If hex --> Convert it to RGB: http://gist.github.com/983661
    var _color = +('0x' + hexstring.slice(1).replace(hexstring.length < 5 && /./g, '$&$&'));
    r = _color >> 16;
    g = _color >> 8 & 255;
    b = _color & 255;
  } else {
    var nameToHex = colourNameToHex(hexstring);
    if (nameToHex !== null) {
      return getContrast(nameToHex);
    }
    r = 0;
    g = 0;
    b = 0;
  }
  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  var hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
  // return colors.modes.light.text;
  // Using the HSP value, determine whether the color is light or dark
  var mode = hsp > 127.5 ? 'light' : 'dark';
  if (!(colors != null && colors.modes)) {
    return mode === 'light' ? '#000' : '#FFF';
  }
  return colors.modes[mode].text;
};
var contrastTransform = function contrastTransform(scale, n) {
  return [getContrast(get(scale, n, n), scale), get(scale, n, n)];
};
var config$8 = {
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  color: {
    property: 'color',
    scale: 'colors'
  },
  opacity: {
    property: 'opacity'
  },
  bg: {
    properties: ['color', 'backgroundColor'],
    scale: 'colors',
    transform: contrastTransform
  }
};
config$8.bgColor = config$8.backgroundColor;
var color = /*#__PURE__*/system(config$8);
var config$7 = {
  alignItems: {
    property: 'alignItems'
  },
  alignContent: {
    property: 'alignContent'
  },
  justifyItems: {
    property: 'justifyItems'
  },
  justifyContent: {
    property: 'justifyContent'
  },
  flexWrap: {
    property: 'flexWrap'
  },
  flexDirection: {
    property: 'flexDirection'
  },
  flex: {
    property: 'flex'
  },
  flexFlow: {
    property: 'flexFlow'
  },
  flexGrow: {
    property: 'flexGrow'
  },
  flexShrink: {
    property: 'flexShrink'
  },
  flexBasis: {
    property: 'flexBasis',
    scale: 'sizes'
  },
  justifySelf: {
    property: 'justifySelf'
  },
  alignSelf: {
    property: 'alignSelf'
  },
  order: {
    property: 'order'
  },
  placeItems: {
    property: 'placeItems'
  },
  placeContent: {
    property: 'placeContent'
  },
  placeSelf: {
    property: 'placeSelf'
  },
  gap: {
    property: 'gap',
    scale: 'sizes'
  }
};
config$7.flexDir = config$7.flexDirection;
var flexbox = /*#__PURE__*/system(config$7);
var config$6 = {
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  gap: {
    property: 'gap',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  rowGap: {
    property: 'rowGap',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  columnGap: {
    property: 'columnGap',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  gridRow: {
    property: 'gridRow'
  },
  gridColumn: {
    property: 'gridColumn'
  },
  gridAutoFlow: {
    property: 'gridAutoFlow'
  },
  gridAutoRows: {
    property: 'gridAutoRows'
  },
  gridAutoColumns: {
    property: 'gridAutoColumns'
  },
  gridTemplateRows: {
    property: 'gridTemplateRows'
  },
  gridTemplateColumns: {
    property: 'gridTemplateColumns'
  },
  gridTemplateAreas: {
    property: 'gridTemplateAreas'
  },
  gridArea: {
    property: 'gridArea'
  }
};
var grid = /*#__PURE__*/system(config$6);
function getWidth(scale, n) {
  return get(scale, n, !isNumber(n) || n > 1 ? n : n * 100 + "%");
}
var config$5 = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  display: {
    property: 'display'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  verticalAlign: {
    property: 'verticalAlign'
  },
  overflow: {
    property: 'overflow'
  },
  overflowX: {
    property: 'overflowX'
  },
  overflowY: {
    property: 'overflowY'
  }
};
config$5.w = config$5.width;
config$5.h = config$5.height;
config$5.minW = config$5.minWidth;
config$5.maxW = config$5.maxWidth;
config$5.minH = config$5.minHeight;
config$5.maxH = config$5.maxHeight;
config$5.d = config$5.display;
var layout = /*#__PURE__*/system(config$5);
var config$4 = {
  appearance: {
    property: 'appearance'
  },
  transform: {
    property: 'transform'
  },
  transformOrigin: {
    property: 'transformOrigin'
  },
  visibility: {
    property: 'visibility'
  },
  userSelect: {
    property: 'userSelect'
  },
  pointerEvents: {
    property: 'pointerEvents'
  },
  overflowWrap: {
    property: 'overflowWrap'
  },
  boxSizing: {
    property: 'boxSizing'
  },
  cursor: {
    property: 'cursor'
  },
  resize: {
    property: 'resize'
  },
  objectFit: {
    property: 'objectFit'
  },
  objectPosition: {
    property: 'objectPosition'
  },
  "float": {
    property: 'float'
  },
  fill: {
    property: 'fill',
    scale: 'colors'
  },
  stroke: {
    property: 'stroke',
    scale: 'colors'
  },
  outline: {
    property: 'outline'
  },
  outlineColor: {
    property: 'outlineColor',
    scale: 'colors'
  }
};
var other = /*#__PURE__*/system(config$4);
var config$3 = {
  position: {
    property: 'position'
  },
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  right: {
    property: 'right',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  left: {
    property: 'left',
    scale: 'space',
    defaultScale: defaultTheme.space
  }
};
config$3.pos = config$3.position;
var position = /*#__PURE__*/system(config$3);
var config$2 = {
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
};
var shadow = /*#__PURE__*/system(config$2);
function getMargin(scale, n) {
  if (!isNumber(n)) {
    return get(scale, n, n);
  }
  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get(scale, absolute, absolute);
  if (!isNumber(value)) {
    return isNegative ? "-" + value : value;
  }
  return value * (isNegative ? -1 : 1);
}
var marginConfig = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginBlockStart: {
    property: 'marginBlockStart',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginBlockEnd: {
    property: 'marginBlockEnd',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginInlineStart: {
    property: 'marginInlineStart',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  },
  marginInlineEnd: {
    property: 'marginInlineEnd',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaultTheme.space
  }
};
marginConfig.m = marginConfig.margin;
marginConfig.mt = marginConfig.marginTop;
marginConfig.mr = marginConfig.marginRight;
marginConfig.mb = marginConfig.marginBottom;
marginConfig.ml = marginConfig.marginLeft;
marginConfig.mx = marginConfig.marginX;
marginConfig.my = marginConfig.marginY;
marginConfig.marginStart = marginConfig.marginInlineStart;
marginConfig.ms = marginConfig.marginInlineStart;
marginConfig.marginEnd = marginConfig.marginInlineEnd;
marginConfig.me = marginConfig.marginInlineEnd;
var margin = /*#__PURE__*/system(marginConfig);
var paddingConfig = {
  padding: {
    property: 'padding',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  paddingBlockStart: {
    property: 'paddingBlockStart',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  paddingBlockEnd: {
    property: 'paddingBlockEnd',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  paddingInlineStart: {
    property: 'paddingInlineStart',
    scale: 'space',
    defaultScale: defaultTheme.space
  },
  paddingInlineEnd: {
    property: 'paddingInlineEnd',
    scale: 'space',
    defaultScale: defaultTheme.space
  }
};
paddingConfig.p = paddingConfig.padding;
paddingConfig.pt = paddingConfig.paddingTop;
paddingConfig.pr = paddingConfig.paddingRight;
paddingConfig.pb = paddingConfig.paddingBottom;
paddingConfig.pl = paddingConfig.paddingLeft;
paddingConfig.px = paddingConfig.paddingX;
paddingConfig.py = paddingConfig.paddingY;
paddingConfig.paddingStart = paddingConfig.paddingInlineStart;
paddingConfig.ps = paddingConfig.paddingInlineStart;
paddingConfig.paddingEnd = paddingConfig.paddingInlineEnd;
paddingConfig.pe = paddingConfig.paddingInlineEnd;
var padding = /*#__PURE__*/system(paddingConfig);
var space = /*#__PURE__*/compose$1(margin, padding);
var config$1 = {
  transition: {
    property: 'transition',
    scale: 'transition.transition'
  },
  transitionProperty: {
    property: 'transitionProperty',
    scale: 'transition.property'
  },
  transitionDuration: {
    property: 'transitionDuration',
    scale: 'transition.duration'
  },
  transitionTiming: {
    property: 'transitionTimingFunction',
    scale: 'transition.timingFn'
  },
  transitionDelay: {
    property: 'transitionDelay',
    scale: 'transition.delay'
  }
};
var transition = /*#__PURE__*/system(config$1);
var config = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    defaultScale: defaultTheme.fontSizes
  },
  fontStyle: {
    property: 'fontStyle'
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  textAlign: {
    property: 'textAlign'
  },
  textDecoration: {
    property: 'textDecoration'
  },
  textOverflow: {
    property: 'textOverflow'
  },
  textTransform: {
    property: 'textTransform'
  },
  whiteSpace: {
    property: 'whiteSpace'
  },
  wordBreak: {
    property: 'wordBreak'
  }
};
var typography = /*#__PURE__*/system(config);
var all$1 = /*#__PURE__*/compose$1(animation, background, border, color, flexbox, grid, layout, other, position, shadow, space, transition, typography);
function getParserDicts() {
  var aliases = {};
  var multiples = {};
  var scales = {};
  var transforms = {};
  all$1.propNames.forEach(function (propName) {
    var _config$transform;
    var config = all$1.config[propName];
    if (!config) {
      return;
    }
    if (config.properties) {
      multiples[propName] = [].concat(config.properties);
    }
    if (config.transform && ((_config$transform = config.transform) == null ? void 0 : _config$transform.name) !== 'getValue') {
      transforms[propName] = config.transform;
    }
    if (config.scale) {
      scales[propName] = config.scale;
    }
    if (config.property && propName !== config.property) {
      aliases[propName] = config.property;
    }
  });
  return {
    aliases: aliases,
    multiples: multiples,
    scales: scales,
    transforms: transforms
  };
}
var _getParserDicts = /*#__PURE__*/getParserDicts(),
  aliases = _getParserDicts.aliases,
  multiples = _getParserDicts.multiples,
  scales = _getParserDicts.scales,
  transforms = _getParserDicts.transforms;
function responsive(styles) {
  if (styles === void 0) {
    styles = {};
  }
  return function (theme) {
    var result = {};
    var breakpoints = get(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));
    if (!styles) return result;
    Object.keys(styles).forEach(function (key) {
      var value = isFunction(styles[key]) ? styles[key](theme) : styles[key];
      if (value === null) {
        return;
      }
      if (!Array.isArray(value)) {
        result[key] = value;
        return;
      }
      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i += 1) {
        var media = mediaQueries[i];
        if (!media) {
          result[key] = value[i];
          continue;
        }
        result[media] = result[media] || {};
        if (value[i] == null) {
          continue;
        }
        result[media][key] = value[i];
      }
    });
    return result;
  };
}
function css(args) {
  return function (props) {
    // const propsTheme = ((props ?? { theme: props }) as { theme: Theme }).theme;
    var theme = _extends({}, defaultTheme);
    if (isTheme(props)) {
      theme = _extends({}, theme, props.theme);
    } else {
      theme = _extends({}, theme, props);
    }
    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);
    Object.keys(styles).forEach(function (key) {
      var x = styles[key];
      var val = isFunction(x) ? x(theme) : x;
      if (val && _typeof(val) === 'object') {
        if (Object.keys(pseudoSelectors).includes(key)) {
          result[pseudoSelectors[key].join(', ')] = css(val)(theme);
          return;
        }
        result[key] = css(val)(theme);
        return;
      }
      var prop = get(aliases, key, key);
      var scaleName = get(scales, prop);
      var scale = get(theme, scaleName, get(theme, prop, {}));
      var transform = get(transforms, prop, get);
      var value;
      // when the val is a number and less than 0, resolve it from the theme
      // using its absolute value and then make the result a negative.
      // otherwise, just resolve the value.
      if (typeof val === 'number' && val < 0) {
        var abs = Math.abs(val);
        var n = transform(scale, abs, abs);
        value = typeof n === 'string' ? "-" + n : n * -1;
      } else {
        value = transform(scale, val, val);
      }
      if (multiples[prop]) {
        var dirs = multiples[prop];
        for (var i = 0; i < Object.keys(dirs).length; i += 1) {
          if (Array.isArray(value)) {
            result[dirs[i]] = value[i];
          } else {
            result[dirs[i]] = value;
          }
        }
        return;
      } else {
        result[prop] = value;
      }
    });
    return result;
  };
}
var variant$1 = function variant(_ref) {
  var _createParser;
  var _ref$prop = _ref.prop,
    prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
    key = _ref.key;
  var sx = function sx(value, scale, props) {
    return css(get(scale, value, null))(props.theme);
  };
  sx.scale = key ? key.includes('defaultStyles') ? key : "variants." + key : "variants";
  sx.defaults = {};
  return createParser((_createParser = {}, _createParser[prop] = sx, _createParser));
};

const buttonStyle = variant$1({ key: "buttons" });
const textStyle = variant$1({ key: "textStyles", prop: "textStyle" });
const colorStyle = variant$1({ key: "colorStyles", prop: "colors" });
const all = compose$1(space, typography, color, layout, flexbox, border, background, position, grid, shadow, buttonStyle, textStyle, colorStyle);
const props = all.propNames;
const createShouldForwardProp = (props) => {
    const regex = new RegExp(`^(${props.join("|")})$`);
    return memoize(prop => isPropValid(prop) && !regex.test(prop));
};
var shouldForwardProp = createShouldForwardProp(props);

const sx = (props) => css(props.sx)(props.theme);
const base = (props) => css(props.__css)(props.theme);
const variant = ({ theme, variant, tx = "variants", }) => css(get(theme, tx + "." + variant, get(theme, variant)))(theme);
const Box = newStyled("div", {
    shouldForwardProp,
})({
    boxSizing: "border-box",
    margin: 0,
    minWidth: 0,
}, base, variant, sx, props => props.css, compose$1(space, layout, typography, color, flexbox));
const Flex = newStyled(Box)({
    display: "flex",
});

const propsMap = Object.assign(Object.assign({}, spacePropMap), { bg: { scale: "colors", props: ["backgroundColor"] }, hover: { scale: "selectors", props: [":hover"] }, disabled: { scale: "selectors", props: [":disabled"] }, enabled: { scale: "selectors", props: [":enabled"] }, focus: { scale: "selectors", props: [":focus"] }, focusVisible: { scale: "selectors", props: [":focus-visible"] }, active: { scale: "selectors", props: [":active"] } });

const mqList = mediaQueryList;
const handleMapping = (prop, decs) => {
    const value = decs[prop];
    const result = { value: [value] };
    const match = propsMap[prop];
    if (match) {
        result.mappedProps = match.props;
        result.value = Array(result.mappedProps.length).fill(value);
        delete decs[prop];
    }
    return result;
};
const parseResponsiveStyles = (decs, customMedia) => {
    const mediaQ = {};
    let mediaQueryList = mqList;
    if (customMedia) {
        mediaQueryList = customMedia;
    }
    for (const prop in decs) {
        const current = decs[prop];
        Object.assign(mediaQ, { [prop]: current.shift() });
        current.forEach((val, i) => {
            mediaQ[mediaQueryList[i]] = Object.assign(mediaQ[mediaQueryList[i]] || {}, {
                [prop]: val,
            });
        });
    }
    return mediaQ;
};
const compose = (decs, customMedia) => {
    const requireParse = {};
    for (const prop in decs) {
        const currentValue = decs[prop];
        const { mappedProps, value } = handleMapping(prop, decs);
        if (typeof currentValue === "object") {
            if (Array.isArray(currentValue)) {
                (mappedProps || [prop]).forEach((p, i) => (requireParse[p] = [...value[i]]));
            }
            else {
                decs[mappedProps || prop] = compose(value[0], customMedia);
            }
        }
        else {
            (mappedProps || [prop]).forEach((p, i) => (decs[p] = value[i]));
        }
    }
    if (Object.keys(requireParse).length > 0) {
        Object.assign(decs, parseResponsiveStyles(requireParse, customMedia));
    }
    return decs;
};

const baseTheme = {
    colors,
    typography: typography$1,
    space: space$1,
    breakpoints,
    effects,
    variants,
};

const defaultFormat = "DD-MM-YYYY";
const toDate = (date, dateFormat = defaultFormat) => moment__default["default"](date, dateFormat);
const dateToString = (date, dateFormat = defaultFormat) => toDate(date).format(dateFormat);
const getYearByDate = (date, dateFormat = defaultFormat) => moment__default["default"](date, dateFormat).year();
const getDate = (date, dateFormat = defaultFormat) => toDate(date, dateFormat).toDate();
const getWeekRangeByDate = (date, dateFormat = defaultFormat) => {
    const mDate = toDate(date, dateFormat);
    return {
        start: mDate.startOf("isoWeek").format(dateFormat),
        end: mDate.endOf("isoWeek").format(dateFormat),
    };
};
const getDateInfo = (date = new Date(), dateFormat = defaultFormat) => {
    const mDate = toDate(date, dateFormat);
    return {
        year: mDate.weekYear(),
        month: mDate.month(),
        week: mDate.isoWeek(),
    };
};

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  toDate: toDate,
  dateToString: dateToString,
  getYearByDate: getYearByDate,
  getDate: getDate,
  getWeekRangeByDate: getWeekRangeByDate,
  getDateInfo: getDateInfo
});

const pluralizeText = (count, text, { showCount = true, singular, plural } = {}) => {
    return `${count && showCount ? `${count} ` : ""}${count > 1 ? `${plural || `${text}s`}` : `${singular || text}`}`;
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  pluralizeText: pluralizeText
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  dateUtils: index$2,
  common: index$3,
  stringUtils: index$1
});

const useBreakpoints = () => {
    const isMobile = reactResponsive.useMediaQuery({
        query: `(max-width: ${BREAKPOINTS.sm})`,
    });
    const isTablet = reactResponsive.useMediaQuery({
        minWidth: BREAKPOINTS.sm,
        maxWidth: BREAKPOINTS.md,
    });
    const isDesktop = reactResponsive.useMediaQuery({
        query: `(min-width: ${BREAKPOINTS.md})`,
    });
    return { isMobile, isTablet, isDesktop };
};

exports.Box = Box;
exports.Flex = Flex;
exports.Typography = Typography;
exports.baseTheme = baseTheme;
exports.compose = compose;
exports.useBreakpoints = useBreakpoints;
exports.utils = index;
